import { put, call } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
    getEmployeeCareerPathSuccess, getEmployeeCareerPathFail,
    getAllEmployeeCareerPathsSuccess, getAllEmployeeCareerPathsFail,
    getEmployeeCareerPathsByEmployeeSuccess, getEmployeeCareerPathsByEmployeeFail,
    assignCareerPathSuccess, assignCareerPathFail,
    updateEmployeeCareerPathSuccess, updateEmployeeCareerPathFail,
    updateEmployeeCareerPathStatusSuccess, updateEmployeeCareerPathStatusFail,
    deleteEmployeeCareerPathSuccess, deleteEmployeeCareerPathFail,
    setEmployeeCareerPathLoading, getAllEmployeeCareerPathsRequest
} from '../actions/employeeCareerPathActions';
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from '../../../api';

export function* getEmployeeCareerPathSaga(action) {
    const url = `${API_BASE_URL}/api/employee-career-paths/${action.payload.id}`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getEmployeeCareerPathSuccess(resp.data));
    } catch (error) {
        yield put(getEmployeeCareerPathFail(error.message));
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}

export function* getAllEmployeeCareerPathsSaga() {
    const token = sessionStorage.getItem('token');
    const url   = `${API_BASE_URL}/api/employee-career-paths`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getAllEmployeeCareerPathsSuccess(resp.data));
    } catch (error) {
        yield put(getAllEmployeeCareerPathsFail(error.message));
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}

export function* getEmployeeCareerPathsByEmployeeSaga(action) {
    const token = sessionStorage.getItem('token');
    const url   = `${API_BASE_URL}/api/employee-career-paths/employee/${action.payload.employeeUserId}`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getEmployeeCareerPathsByEmployeeSuccess(resp.data));
    } catch (error) {
        yield put(getEmployeeCareerPathsByEmployeeFail(error.message));
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}

export function* assignCareerPathSaga(action) {
    const url  = `${API_BASE_URL}/api/employee-career-paths`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload });
        yield put(assignCareerPathSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Parcours assigné avec succès',
            timer: 2000, showConfirmButton: false
        });
        yield put(getAllEmployeeCareerPathsRequest());
    } catch (error) {
        yield put(assignCareerPathFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: "Erreur lors de l'assignation",
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}

export function* updateEmployeeCareerPathSaga(action) {
    const { id, data } = action.payload;
    const url = `${API_BASE_URL}/api/employee-career-paths/${id}`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        const resp = yield call(putRequest, { url, data });
        yield put(updateEmployeeCareerPathSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Parcours mis à jour avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        yield put(updateEmployeeCareerPathFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: 'Erreur lors de la mise à jour',
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}

export function* updateEmployeeCareerPathStatusSaga(action) {
    const { id, status } = action.payload;
    const url = `${API_BASE_URL}/api/employee-career-paths/${id}/status?status=${status}`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        yield call(putRequest, { url, data: {} });
        yield put(updateEmployeeCareerPathStatusSuccess(id, status));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: '', text: 'Statut mis à jour avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        yield put(updateEmployeeCareerPathStatusFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: '', text: 'Erreur lors du changement de statut',
            timer: 2000, showConfirmButton: false
        });
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}

export function* deleteEmployeeCareerPathSaga(action) {
    const url = `${API_BASE_URL}/api/employee-career-paths/${action.payload.id}`;
    yield put(setEmployeeCareerPathLoading(true));
    try {
        yield call(deleteRequest, { url });
        yield put(deleteEmployeeCareerPathSuccess(action.payload.id));
        yield call([Swal, Swal.fire], {
            icon: 'success', title: 'Succès', text: 'Assignation supprimée avec succès',
            timer: 2000, showConfirmButton: false
        });
    } catch (error) {
        const errorMessage = error.response?.data?.message
            || error.response?.data?.error
            || error.message
            || 'Erreur lors de la suppression';
        yield put(deleteEmployeeCareerPathFail(errorMessage));
        yield call([Swal, Swal.fire], {
            icon: 'error', title: 'Erreur de suppression', text: errorMessage,
            confirmButtonText: 'OK', confirmButtonColor: '#d33'
        });
    } finally {
        yield put(setEmployeeCareerPathLoading(false));
    }
}